import React from 'react';
import {Users} from './blocks';
import {UserDetailsData} from '@/pages/buddy/types/UserDetailsData.ts';

interface UsersContentProps {
    users: UserDetailsData[];
    loading: boolean;
}

const UsersContent: React.FC<UsersContentProps> = ({users, loading}) => {
    return (
        <div>
            <Users users={users} loading={loading}/>
        </div>
    );
};

export {UsersContent};
